<template>
  <v-data-table
    :headers="headers"
    :items="estudios"
    class="transparent"
    :loading="loading"
    :options="{ page: false }"
    :hide-default-footer="true"
  >
    <template v-slot:[`item.opciones`]="{ item }">
      <span class="d-flex align-center">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              <IconButton class="mr-2" icon="mdi-pencil" variant="primary" @click="$emit('edit', item)" />
            </span>
          </template>
          <span>Editar Estudio</span>
        </v-tooltip>
      </span>
    </template>
  </v-data-table>
</template>

<script>
import IconButton from '../../base/IconButton.vue'

export default {
  components: {
    IconButton,
  },
  props: {
    estudios: {
      type: Array,
      required: true,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      headers: [
        { text: 'Institución', value: 'institucion', width: '20%' },
        { text: 'Generación', value: 'generacion', width: '15%' },
        { text: 'Estatus', value: 'CatEstatusEstudio.title', width: '15%' },
        { text: 'Comprobante', value: 'ComprobanteEstudio.title', width: '15%' },
        { text: 'Grado', value: 'CatEstudios.title', width: '15%' },
        { text: 'Observaciones', value: 'observaciones', width: '30%' },
        { text: 'Opciones', value: 'opciones', align: 'center', width: '10%', sortable: false },
      ],
    }
  },
}
</script>
